import compact from "lodash/compact";

export const tokenizeFilterString = (term: string): string[] =>
  term.trim().toLocaleLowerCase().split(/\s+/g).filter(Boolean);

export const orderlessPredicate = <T>(
  textFn: (x: T, index: number) => string | undefined | (string | undefined)[],
  term: string | undefined,
): ((x: T, index: number) => boolean) => {
  const matcher = (token: string, text: string) => text.toLocaleLowerCase().includes(token);
  if (!term?.trim()) {
    return () => true;
  }
  const tokens = tokenizeFilterString(term);
  return (x, index) => {
    const texts = textFn(x, index);
    const preppedTexts = compact(Array.isArray(texts) ? texts : [texts]);
    return tokens.every((token) => preppedTexts.some((s) => matcher(token, s)));
  };
};

export const orderlessFilter = <T>(
  xs: T[],
  text: (x: T, index: number) => string | undefined | (string | undefined)[],
  term: string | undefined,
): T[] => xs.filter(orderlessPredicate(text, term));
